import { types, creators } from './actions.js';
import reducer, { initialState } from './reducer.js';
import sagas, { takes } from './sagas/index.js';
import selectors from './selectors.js';

var text = {
  store: 'text',
  initialState: initialState,
  reducer: reducer,
  types: types,
  creators: creators,
  sagas: sagas,
  takes: takes,
  selectors: selectors
};
var text$1 = text;

export { text$1 as default };
//# sourceMappingURL=index.js.map
